import React from "react";

/**
 * The official Golf Power Play coin.
 * Renders the designed "G with vertical staff" coin asset.
 * Falls back to a styled SVG if the image fails to load.
 */
export default function CoinIcon({ className = "h-5 w-5", alt = "Golf Power Play coin", title }) {
    const [errored, setErrored] = React.useState(false);

    if (errored) {
        return (
            <svg viewBox="0 0 24 24" className={className} aria-hidden={!title} role={title ? "img" : undefined}>
                {title ? <title>{title}</title> : null}
                <defs>
                    <linearGradient id="coinFallbackGrad" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#F2D175" />
                        <stop offset="55%" stopColor="#D9B259" />
                        <stop offset="100%" stopColor="#A7822E" />
                    </linearGradient>
                </defs>
                <circle cx="12" cy="12" r="10" fill="url(#coinFallbackGrad)" stroke="#5B4716" strokeWidth="0.9" />
                <text x="12" y="15.5" textAnchor="middle" fontSize="11" fontWeight="900" fill="#3B2F10">G</text>
            </svg>
        );
    }

    return (
        <img
            src="/brand/gpp-coin.jpg"
            alt={alt}
            title={title}
            onError={() => setErrored(true)}
            className={`${className} object-contain select-none drop-shadow-[0_2px_4px_rgba(91,71,22,0.25)]`}
            draggable={false}
        />
    );
}
